var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-mark",style:(_vm.markStyles)},[_c('img',{staticClass:"wh100",attrs:{"src":require("@/assets/img/auth-mark.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }